<nb-card class="dlg-container mb-0 mobilePopup" style="max-height:95vh;min-width:30vw; height: auto !important;">
  <nb-card-header class="d-flex align-items-center title">
    <div class="title">Update field</div>
    <button nbButton static="basic" ghost shape="round" size="small" class="ml-auto" (click)="close()">
      <nb-icon icon="close"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <nb-card-body>
      <form #form="ngForm">
        <h5 class="mb-1">Field Details</h5>
        <div class="row mb-1">
          <label class="col-4">Label</label>
          <div class="col-8">
            <nb-form-field>
              <input nbInput fullWidth [(ngModel)]="field.templateOptions.label" name="label" placeholder="Label">
            </nb-form-field>
          </div>
        </div>
        <div class="row mb-1" *ngIf="field.templateOptions.isImperial != undefined">
          <label class="col-4">Is Imperial</label>
          <div class="col-8">
            <nb-checkbox fullWidth [checked]="field.templateOptions.isImperial"
            (checkedChange)="field.templateOptions.isImperial = ($event)"></nb-checkbox>
            </div>
          </div>
        <div class="row mb-1">
          <label class="col-4">Required</label>
          <div class="col-8">
            <nb-checkbox fullWidth [checked]="field.templateOptions.required"
              (checkedChange)="field.templateOptions.required = ($event)"></nb-checkbox>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-4">Placeholder</label>
          <div class="col-8">
            <nb-form-field>
              <input nbInput fullWidth [(ngModel)]="field.templateOptions.placeholder" name="placeholder" placeholder="placeholder">
            </nb-form-field>
          </div>
        </div>
        <div *ngIf="field.templateOptions.options">
          <div>
            <h4 class="mb-1">Options</h4>
          </div>
          <div class="list-group">
            <div class="list-group-item row mb-1 position-relative" *ngFor="let option of field.templateOptions.options; let i = index">
              <div class="col-4">
                <label>Option Label</label>
              </div>
              <div class="col-8">
                <nb-form-field>
                  <input nbInput fullWidth [(ngModel)]="option.label" name="optionLabel{{i}}" placeholder="Option Label">
                </nb-form-field>
              </div>
              <!-- <div class="col-4">
                <label>Option Value</label>
              </div>
              <div class="col-8">
                <nb-form-field>
                  <input nbInput fullWidth [(ngModel)]="option.value" name="optionValue{{i}}" placeholder="Option Value">
                </nb-form-field>
              </div> -->
              <button nbButton static="basic" ghost shape="round" size="small" type="button" class="position-absolute"
              style="top: 0; right: 0;"
                (click)="removeOption(i)">
                <nb-icon icon="close"></nb-icon>
              </button>
            </div>
            <div class="list-group-item">
              <button nbButton shape="round" size="small" type="button" class="ml-auto" (click)="addOption()">
                add
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <button nbButton status="success" [disabled]="validKeyString" class="mt-4" (click)="onSubmit()">Submit</button>
          </div>
        </div>
      </form>
    </nb-card-body>
  </nb-card-body>
</nb-card>
